import { render, staticRenderFns } from "./browser-not-supported-overlay.vue?vue&type=template&id=2c37cb5a"
import script from "./browser-not-supported-overlay.vue?vue&type=script&lang=js"
export * from "./browser-not-supported-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c37cb5a')) {
      api.createRecord('2c37cb5a', component.options)
    } else {
      api.reload('2c37cb5a', component.options)
    }
    module.hot.accept("./browser-not-supported-overlay.vue?vue&type=template&id=2c37cb5a", function () {
      api.rerender('2c37cb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/browser-not-supported-overlay.vue"
export default component.exports